"use client";
import { title, subtitle } from "@/components/primitives";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownSection,
  DropdownItem,
} from "@heroui/dropdown";

import { Button } from "@heroui/button";
import { Form } from "@heroui/form";
import { Input } from "@heroui/input";
import { Image } from "@heroui/image";

export default function ObstacleCourse() {
  return (
     <section className="flex flex-col items-center justify-center">
      <div className="inline-block text-center justify-center w-[90vW] max-w-[1000px] bg-white/80 gap-4 py-8 md:py-10 " style={{ zIndex:"10", position: "relative"}} >
        <div>
          <h1 className={title()}>Elektro terapie</h1>
          <div className={subtitle({ class: "mt-4 px-4"})} style={{textAlign:"left"}}>
          <h1 className={title()}>O čem to je?</h1>
          <br/>
          <br/>
          <p style={{textAlign:"left", textIndent:"30px"}}>
            Tento systém je založen na elektrické stimulaci vašeho svalstva pomocí několika elektrických impulsů za sekundu a tím dochází k roztažení a stažení až 95 % svalů na těle. Po jejich aktivaci dochází k celkovému zpevnění a správné funkci těla.
          </p>
          <br/>
          <h1 className={title()}>Jak často je potřeba cvičit?</h1>
          <br/>
          <br/>
          <p style={{textAlign:"left", textIndent:"30px"}}>
            Cvičení probíhá na týdenní bázi za účelem dosažení nejlepších výsledků. První cvičení probíhá formou školení a seznámení kde je na něj vyčleněna 1. hodina. Každá další lekce je v délce 30 minut (doba cvičení + nastrojení a odstrojení)
          </p>
          <br/>
          </div>

          <Image src="/images/EMS.jpeg" className="w-fill"/>

          <div className={subtitle({ class: "mt-4 px-4"})} style={{textAlign:"left"}}>
          <h1 className={title()}>Pro koho je EMS vhodné?</h1>
          <br/>
          <br/>
          <p style={{textAlign:"left", textIndent:"30px"}}>
            EMS (elektrostimulační trénink) je ideální pro časově vytížené lidi, vrcholové sportovce, začátečníky, seniory nebo osoby s omezenou pohyblivostí, které hledají efektivní cvičení bez zátěže kloubů. Díky 20minutovým lekcím, které posilují celé tělo (včetně hlubokých svalů), je vhodné pro tvarování postavy, redukci tuku, úlevu od bolesti zad či rehabilitaci.
          </p>
          <br/>
          </div>
        </div>
      </div>
    </section>
  );
}

